import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { Box, Button } from '@rsos/components/capstone/base';
import { useFlag } from '@rsos/flags';
import {
  resetSelectedAirAmbulance,
  setFormPageToShow,
} from '@rsos/reduxDataStore';
import { setPreselectedLandingZone } from '@rsos/reduxDataStore/src/features/airAmbulance/airAmbulanceSlice';
import {
  setCardsToRender,
  AIR_AMBULANCE_CARD,
} from '@rsos/reduxDataStore/src/features/mapCard/mapCardSlice';
import {
  openResourcePanel,
  setResourcePanelView,
  setSelectedRequest,
} from '@rsos/reduxDataStore/src/features/resourceRequests';
import { trackOpenAirAmbulanceRequestForm } from '../../../../../gainsightTrackings/airAmbulanceTrackings';
import { FORM_PAGES } from '../../../../AirAmbulanceForm/AirAmbulanceForm/constants';
import LocationSummary, {
  StyledLocationSummary,
} from '../../../../Map/MapCard/LocationSummary';

const LocationContainer = styled(Box)`
  ${StyledLocationSummary} {
    margin-bottom: 0;
  }
`;

const ButtonContainer = styled(Box)`
  border: ${({ isFromMap, theme }) =>
    !isFromMap && `1px solid ${theme.colors.heavyLineOutline};}`}
  margin: ${({ isFromMap }) => !isFromMap && '11px 0'};
  padding: ${({ isFromMap }) => !isFromMap && '13px'};
`;

const useSpatialObject = () => {
  return useSelector(state => {
    return state.mapCard.mapCardData.spatialObject;
  });
};

const AirAmbulanceButton = props => {
  const dispatch = useDispatch();
  const spatialObject = useSpatialObject();
  const [isLoading, setIsLoading] = useState(false);
  const isFromMap = !props?.data?.spatial_object_id; // It's from the map if this data is falsy
  const hasGenericResourceRequests = useFlag('generic_resource_requests');

  const handleRequestAirAmbulance = async () => {
    setIsLoading(true);
    try {
      dispatch(setPreselectedLandingZone(spatialObject));

      trackOpenAirAmbulanceRequestForm({
        source: 'landing_zone_map_marker',
        landingZoneName: spatialObject?.name,
        landingZoneId: spatialObject?.id,
      });

      if (hasGenericResourceRequests) {
        dispatch(setSelectedRequest(null));
        dispatch(openResourcePanel());
        dispatch(setResourcePanelView('air_ambulance'));
      } else {
        await dispatch(resetSelectedAirAmbulance());
        dispatch(setFormPageToShow(FORM_PAGES.FORM));
        dispatch(setCardsToRender(AIR_AMBULANCE_CARD));
      }
    } finally {
      setIsLoading(false);
    }
  };

  const address = spatialObject?.attributes?.address;
  const coordinates = {
    lat: spatialObject?.center?.coordinates[1],
    lng: spatialObject?.center?.coordinates[0],
  };

  return (
    <>
      <LocationContainer
        px="12px"
        isFromMap={isFromMap}
        className="LocationContainer"
      >
        {!isFromMap && (
          <LocationSummary
            location={address}
            coordinates={coordinates}
            overridden
          />
        )}
      </LocationContainer>

      <Box justify="center" px="13px">
        <ButtonContainer isFromMap={isFromMap}>
          <Button onClick={handleRequestAirAmbulance} disabled={isLoading}>
            {props.schema.componentProperties.properties.actionText}
          </Button>
        </ButtonContainer>
      </Box>
    </>
  );
};

export default AirAmbulanceButton;
